/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Modal,
} from 'antd';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceivedValues } from 'utils/formatValues';
import currencyFormatter from 'utils/currencyFormatter';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { checkToken } from 'api/utils';
import { onError } from 'utils/handlers';
import {
  getRetirosDeAhorrosDetalle,
  postRetiroDeAhorroDetalle,
  // patchRetiroDeAhorroDetalle,
  deleteRetiroDeAhorroDetalle,
} from 'api/nominas/retiroDeAhorros/retiroDeAhorrosDetalles';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import CurrencyInput from 'components/CurrencyInput';
import { getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getAreas } from 'api/catalogos';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getPlazas } from 'api/catalogos/plazas';
import { getDescuentos } from 'api/nominas/descuentos/descuentos';
import { getRetiroDeAhorro } from 'api/nominas/retiroDeAhorros/retiroDeAhorros';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

// Componentes
import RetiroDeAhorrosDetallesTable from './RetiroDeAhorrosDetallesTable';

export const retiroDeAhorrosDetallesPermission = {
  permissionModel: 'descuentodevolucionahorrodetalle',
  catalogsModels: [],
  tabsModels: [],
};

const RetiroDeAhorrosDetalles = ({
  permission,
  selectedTipoNominaEmpleado,
  selectedRetiroAhorro,
  formEncabezado,
  estatusAutorizadoInactivo,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [form] = Form.useForm();
  const [open, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState();
  const [empleados, setEmpleados] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [asignacionPlazas, setAsignacionPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [selectedEmpleados, setSelectedEmpleados] = useState([]);
  const [descuentosEmpleadosFiltered, setDescuentosEmpleadosFiltered] = useState([]);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        nombreEmpleado: e?.empleado,
        puesto: e?.empleado,
        area: e?.empleado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const formatReceivedCloneSon = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        noNombreEmpleado: e?.empleado,
        puestoTabla: e?.empleado,
        areaTabla: e?.empleado,
        importe_acumulado_tabla: e?.importe_acumulado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const areaBuscar = (value) => {
    const stack = [...areas];
    while (stack.length > 0) {
      const areaNueva = stack.pop();
      if (areaNueva.clave === value?.toString() || areaNueva.value === value?.toString()) {
        return areaNueva;
      }
      if (areaNueva.children) {
        stack.push(...areaNueva.children);
      }
    }
    return null;
  };

  const normalizeData = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const unidad_responsable = normalizeData(clone.unidad_responsable);
        const centro_de_costo = normalizeData(clone.centro_de_costo);
        if (!unidad_responsable.length && !centro_de_costo.length) {
          delete clone.unidad_responsable;
          delete clone.centro_de_costo;
          return ({
            id: clone.id,
            title: `${clone.clave} - ${clone.descripcion}`,
            value: `${clone.clave}/${clone.nivel}`,
            tableTitle: clone.descripcion,
            clave: clone.clave,
          });
        }
        if (unidad_responsable) {
          return ({
            id: clone.id,
            title: `${clone.clave} - ${clone.descripcion}`,
            value: `${clone.clave}/${clone.nivel}`,
            children: unidad_responsable,
            tableTitle: clone.descripcion,
            clave: clone.clave,
            // disabled: true,
          });
        }
        return ({
          id: clone.id,
          title: `${clone.clave} - ${clone.descripcion}`,
          value: `${clone.clave}/${clone.nivel}`,
          children: centro_de_costo,
          tableTitle: clone.descripcion,
          clave: clone.clave,
          // disabled: true,
        });
      });
      return output;
    }
    return false;
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRetirosDeAhorrosDetalle({ descuento_devolucion_ahorro: selectedRetiroAhorro });
    const _dataDesc = await getDescuentos();
    const dataFiltered = _dataDesc?.filter((d) => !_data?.some((a) => a?.empleado === d?.empleado));
    setData(formatReceivedClone(_data));
    setDescuentosEmpleadosFiltered(formatReceivedCloneSon(dataFiltered));
    formEncabezado.setFieldValue('no_empleados', _data.length);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposNominaEmpleado,
        _empleados,
        _puestos,
        _areas,
        _asignacionPlazas,
        _plazas,
        _descuentosEmpleados,
        _data,
      ] = await Promise.all([
        getTiposDeNominasEmpleados(),
        getEmpleadosFiltered(),
        getPuestos(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getAdministracionDePlazas(),
        getPlazas(),
        getDescuentos(),
        getRetirosDeAhorrosDetalle({ descuento_devolucion_ahorro: selectedRetiroAhorro }),
      ]);
      const formattedURS = normalizeData(_areas);
      if (mounted) {
        setTiposDeNominaEmpleado(_tiposNominaEmpleado);
        setEmpleados(_empleados);
        setPuestos(_puestos);
        setAreas(formattedURS);
        setAsignacionPlazas(_asignacionPlazas);
        setPlazas(_plazas);
        const descEmpFiltered = _descuentosEmpleados?.filter((d) => !_data?.some((a) => a?.empleado === d?.empleado));
        setDescuentosEmpleadosFiltered(formatReceivedCloneSon(descEmpFiltered));
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedEmpleados([]);
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const postArrayValues = async (array) => {
    const promises = array.map((vals) => postRetiroDeAhorroDetalle(vals));
    await Promise.all(promises);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const mappedValues = selectedEmpleados.map((descEmp) => {
        const importeRetiro = form.getFieldValue('importe_de_retiro');
        return {
          ...descEmp,
          importe_devolucion: importeRetiro,
          descuento_devolucion_ahorro: selectedRetiroAhorro,
          calculada: false,
          nomina: null,
          importe_acumulado: 0,
          tipo_de_nomina_empleado: selectedTipoNominaEmpleado,
        };
      });
      await postArrayValues(mappedValues);
      const selectedRetiroAhorroData = await getRetiroDeAhorro(selectedRetiroAhorro);
      formEncabezado.setFieldValue('importe_acumulado_total', selectedRetiroAhorroData?.importe_acumulado_total);
      onCancel();
      await fetchData();
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteRetiroDeAhorroDetalle(key);
        if (deleted) {
          setVisibleAlert(false);
          const selectedRetiroAhorroData = await getRetiroDeAhorro(selectedRetiroAhorro);
          formEncabezado.setFieldValue('importe_acumulado_total', selectedRetiroAhorroData?.importe_acumulado_total);
          await fetchData();
          onCancel();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const contentDeleteMessage = () => {
    const idEmp = data?.find((d) => d?.id === selectedRowKeys[0])?.empleado;
    const empleadoInfo = empleados?.find((emp) => emp?.id === idEmp);
    return `Empleado ${empleadoInfo?.nombre} ${empleadoInfo?.apellido_materno || ''} ${empleadoInfo?.apellido_paterno || ''}`;
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
  };

  const columns = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (val) => empleados?.find((emp) => emp?.id === val)?.numero_de_empleado,
    },
    {
      titleText: 'Nombre del Empleado',
      dataIndex: 'nombreEmpleado',
      key: 'nombreEmpleado',
      width: 300,
      render: (val) => {
        const empleado = empleados.find((emp) => emp?.id === val);
        return `${empleado?.nombre} ${empleado?.apellido_materno || ''} ${empleado?.apellido_paterno || ''}`;
      },
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 300,
      render: (val) => {
        const asignacionPlaza = asignacionPlazas?.find((asigPlaza) => asigPlaza?.empleado === val);
        const plaza = plazas?.find((pl) => pl?.id === asignacionPlaza?.plaza);
        const puestoEmp = puestos?.find((puesto) => plaza?.puesto === puesto?.id)?.descripcion;
        return `${puestoEmp || ''}`;
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'area',
      key: 'area',
      width: 300,
      render: (val) => {
        const asignacionPlaza = asignacionPlazas?.find((asigPlaza) => asigPlaza?.empleado === val);
        const plaza = plazas?.find((pl) => pl?.id === asignacionPlaza?.plaza);
        const areaEmp = areaBuscar(plaza?.area_content_id)?.tableTitle;
        return `${areaEmp || ''}`;
      },
    },
    {
      titleText: 'Importe Acumulado',
      dataIndex: 'importe_acumulado',
      key: 'importe_acumulado',
      width: 300,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe de Retiro',
      dataIndex: 'importe_devolucion',
      key: 'importe_devolucion',
      width: 300,
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={data}
          cols={columns}
          allowExport
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickDelete,
          }}
          allowSearch
          addText="Agregar Empleados"
          deleteText="Eliminar Empleados"
          disableAdd={estatusAutorizadoInactivo}
          disableDelete={estatusAutorizadoInactivo}
          permission={permission}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Empleados`}
              onFinish={onFinish}
              allowSave={selectedEmpleados.length}
              onCancel={onCancel}
              loading={loading}
            />
            )}
          onCancel={onCancel}
          forceRender
          width={900}
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="tipo_nomina_empleado"
                  label="Tipo Nómina Empleado"
                  hasFeedback
                  initialValue={selectedTipoNominaEmpleado}
                >
                  <Select
                    dataSource={tiposDeNominaEmpleado}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <CurrencyInput
                  name="importe_de_retiro"
                  label="Importe de Retiro"
                  hasFeedback
                  rules={rules.required}
                  allowClear
                />
              </Col>
            </Row>
          </Form>
          <RetiroDeAhorrosDetallesTable
            permission={permission}
            selectedEmpleados={selectedEmpleados}
            setSelectedEmpleados={setSelectedEmpleados}
            descuentosEmpleados={descuentosEmpleadosFiltered}
            modalVisible={open}
          />
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={contentDeleteMessage()}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default RetiroDeAhorrosDetalles;
